import React from "react";

const Modal = ({ isOpen, onClose, title, children, footer }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            role="dialog"
            aria-modal="true"
        >
            <div className="relative bg-white rounded-lg shadow-lg max-w-md w-full">
                {/* Header */}
                <div className="p-4 border-b flex items-center justify-between">
                    <h2 className="text-lg font-bold text-[#105A3E]">{title}</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-900 text-2xl leading-none cursor-pointer"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>

                {/* Content */}
                <div className="p-4">{children}</div>

                {/* Footer */}
                {footer && <div className="p-4 border-t">{footer}</div>}
            </div>
        </div>
    );
};

export default Modal;
